export const STATUS_VARIANTS = {
  pending: 'secondary',
  generated: 'info',
  exchanged: 'success',
  error: 'danger',
  conflict: 'warning',
};

// What the per-user Transfer button does, from the user's next_action.
export const NEXT_ACTION_LABELS = {
  generate: 'Fetch transfer_sub',
  exchange: 'Exchange to HK',
};

export const formatDate = (val) => {
  if (!val) return '—';
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? val : d.toLocaleString();
};

// "000585.fb8abaebe56b49cfad16a70bb7099e84.0244" -> "000585.fb8a…0244": enough to tell rows apart.
export const shortSub = (sub) => {
  if (!sub) return '';
  const parts = String(sub).split('.');
  if (parts.length === 3 && parts[1].length > 4) return `${parts[0]}.${parts[1].slice(0, 4)}…${parts[2]}`;
  return sub.length > 18 ? `${sub.slice(0, 10)}…${sub.slice(-4)}` : sub;
};

// Before the exchange apple_id is the VI sub; after it apple_id is the HK sub and the VI one
// is kept in apple_sub_vi (so a rollback can put it back).
export const subsOf = (user) => {
  const isHk = user?.apple_sub_team === 'hk';
  return {
    vi: isHk ? user?.apple_sub_vi : user?.apple_id,
    hk: isHk ? user?.apple_id : null,
  };
};
